module.exports = __webpack_public_path__ + "static/media/danger-icon.78e769ee.svg";